import { getIn, useFormikContext } from "formik"
import { useEffect, useMemo, useState, useTransition } from "react";

import clsx from 'clsx';
import { useDebounce } from "../../../../../_metronic/helpers";
import { createDLMROI, createSiteDLMROI } from "../../../core/doclabel";
import { filter, orderBy } from "lodash";
import { getErrorMessage } from "../../../../components/helpers";

type Props = {
  appID?: number,
  siteID?: number,
  srcField?: string
}

export const DLMCreateROIButton = ({appID, siteID, srcField = 'roiModels'} : Props) => {


  const [goText, setGoText] = useState<string>('');        
  const debouncedGoText = useDebounce(goText, 800);

  const [ isLoading, LoadValues] = useTransition();

  const { values, setFieldValue } = useFormikContext() ;

  const hasROIModels = useMemo(() => {
    if (! values) return false;

    const roiModels = getIn(values, srcField);

    return roiModels && roiModels.length > 0;

  }, [values, srcField]);

  const createROIModels =  () =>  {    
    
    if (isLoading || (! (appID || siteID)) || hasROIModels) {        
      return;
    }
    
    LoadValues( () => {            
      const createFN = siteID ? createSiteDLMROI : createDLMROI;
      const idVal = siteID ? siteID : (appID ? appID : 0);

      createFN(idVal)
      .then( res => {
        if (! res.data && res.data.length > 0) {
          console.error('Create ROI : Something happened');
        }
        setFieldValue(srcField, orderBy( filter(res.data, (o: any) => (! o?.deleted)), ['no'], ['asc']));
      })
      .catch( err => {
        console.error(getErrorMessage(err));
      })
      .finally(() => {
        setGoText('');
      })
    })
  };


  useEffect(() => {    
    if (debouncedGoText !== 'GO') return;      
    // run only once
    createROIModels();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedGoText])
  
  return (
    <div>
      { (! hasROIModels) &&
      <span className="text-muted fs-7 me-2">Click to create ROI →</span>     
      }
      <button
        type="button"
        className={clsx('btn btn-sm btn-primary py-1 mb-1 px-3',
        { 'btn-primary': ! hasROIModels},
        { 'btn-secondary': hasROIModels},
        )}
        onClick={() => setGoText('GO')}
        disabled={isLoading}
      >
        <span className='indicator-label'>Create ROI</span>        
      </button>
    </div>  

  )


}